import axios from 'axios'
import moment from 'moment'

const TOKEN_CACHED_SECONDS = 600
const DELAY_TO_RELOAD = 3000

const checkDates = date => {
  const start = moment(date)
  const now = moment()

  const duration = moment.duration(now.diff(start))
  const seconds = duration.asSeconds()

  if (seconds > TOKEN_CACHED_SECONDS) return true
  return false
}

const redirect = url => {
  setTimeout(() => {
    window.location.replace(url)
  }, DELAY_TO_RELOAD)
}

const updateBearer = () => {
  const bearer = JSON.parse(localStorage.getItem('bearer'))

  const newBearer = { ...bearer, date: moment() }

  localStorage.setItem('bearer', JSON.stringify(newBearer))
}

const urlIdentity = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'http://localhost:5001'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://identity-api.openflex-preprod.eu'
  }
  return 'https://identity-api.openflex.eu'
}

const urlCustomer = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'http://localhost:5000'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://customer-api.openflex-preprod.eu'
  }
  return 'https://customer-api.openflex.eu'
}

const urlGeocoding = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'http://localhost:5014'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://geocoding-api.openflex-preprod.eu'
  }
  return 'https://geocoding-api.openflex.eu'
}

const urlSelling = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'http://localhost:5002'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://selling-api.openflex-preprod.eu'
  }
  return 'https://selling-api.openflex.eu'
}

const urlScoring = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'http://localhost:5003'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://scoring-api.openflex-preprod.eu'
  }
  return 'https://scoring-api.openflex.eu'
}

const urlConfigurator = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'http://localhost:5004'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://configurator-api.openflex-preprod.eu'
  }
  return 'https://configurator-api.openflex.eu'
}

const urlGateway = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'http://localhost:5010'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://gateway-api.openflex-preprod.eu'
  }
  return 'https://gateway-api.openflex.eu'
}

const urlFileRender = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'http://localhost:5006'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://filerender-api.openflex-preprod.eu'
  }
  return 'https://filerender-api.openflex.eu'
}

const urlLegacy = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'http://localhost:5008'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://legacy-api.openflex-preprod.eu'
  }
  return 'https://legacy-api.openflex.eu'
}

export const urlMedia = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'https://media.openflex-preprod.eu'
  }
  if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
    return 'https://media.openflex-preprod.eu'
  }
  return 'https://media.openflex.eu'
}

const getTimeout = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 100000
  }
  return 50000
}

/**
 * The Request class allows you to centralize calls to the outside of the application, including the server
 */
class Requester {
  /**
   * Les variables utilisées pour communiquer avec le serveur
   *
   * @static
   */
  static API = {
    urlCustomer: urlCustomer(),
    urlIdentity: urlIdentity(),
    urlSelling: urlSelling(),
    urlScoring: urlScoring(),
    urlConfigurator: urlConfigurator(),
    urlGateway: urlGateway(),
    urlGeocoding: urlGeocoding(),
    urlFileRender: urlFileRender(),
    urlLegacy: urlLegacy(),
    timeout: getTimeout()
  }

  /**
   * Envoi POST d'une requête vers l'API
   *
   * @param {string} method le nom de la méthode définie dans le tableau de méthodes ci-dessus
   * @param {*} datas un objet de données à envoyer dans la méthode
   * @static
   * @return {Promise} une promesse avec les données renvoyées par l'API
   */

  static getRequest = ({
    urlApi,
    url,
    params,
    redirectMessage,
    hasToken = true,
    rawError = false
  }) => {
    const { API } = Requester

    const bearer = JSON.parse(localStorage.getItem('bearer'))

    const headers = hasToken
      ? {
          Authorization: `Bearer ${bearer && bearer.jwt}`
        }
      : {}

    return new Promise((resolve, reject) => {
      axios({
        baseURL: API[urlApi],
        method: 'get',
        url,
        params,
        timeout: API.timeout,
        headers
      })
        .then(response => {
          const { data } = response

          if (data) {
            if (data.error) {
              if (data.error.message) reject(data.error.message)

              reject(data.error)
            } else {
              resolve(data)
            }
          } else {
            // reject('Aucune donnée');
          }
        })
        .catch(error => {
          const mustReload = bearer && checkDates(bearer.date)
          if (mustReload) {
            reject(redirectMessage)
            redirect(bearer.pathname)
          } else {
            reject(rawError ? error : error.message)
            if (rawError) {
              throw error
            }
          }
        })
        .finally(() => updateBearer())
    })
  }

  static patch = ({ urlApi, url, params, redirectMessage }) => {
    const { API } = Requester
    const bearer = JSON.parse(localStorage.getItem('bearer'))

    return new Promise((resolve, reject) => {
      axios({
        baseURL: API[urlApi],
        method: 'patch',
        url,
        data: params,
        timeout: API.timeout,
        headers: {
          Authorization: `Bearer ${bearer && bearer.jwt}`
        }
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(bearer && checkDates(bearer.date) ? redirectMessage : error.message)
        })
        .finally(() => updateBearer())
    })
  }

  static put = ({ urlApi, url, params, redirectMessage }) => {
    const { API } = Requester
    const bearer = JSON.parse(localStorage.getItem('bearer'))

    return new Promise((resolve, reject) => {
      axios({
        baseURL: API[urlApi],
        method: 'put',
        url,
        data: params,
        timeout: API.timeout,
        headers: {
          Authorization: `Bearer ${bearer && bearer.jwt}`
        }
      })
        .then(response => {
          const { data } = response

          if (data) {
            if (data.error) {
              if (data.error.message) reject(data.error.message)

              reject(data.error)
            } else {
              resolve(data)
            }
          } else {
            // reject('Aucune donnée');
          }
        })
        .catch(error => {
          reject(bearer && checkDates(bearer.date) ? redirectMessage : error.message)
        })
        .finally(() => updateBearer())
    })
  }

  static post = ({ urlApi, url, params, redirectMessage }) => {
    const { API } = Requester
    const bearer = JSON.parse(localStorage.getItem('bearer'))

    return new Promise((resolve, reject) => {
      axios({
        baseURL: API[urlApi],
        method: 'post',
        url,
        data: params,
        timeout: API.timeout,
        headers: {
          Authorization: `Bearer ${bearer && bearer.jwt}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          const { data } = response

          if (data) {
            if (data.error) {
              if (data.error.message) reject(data.error.message)

              reject(data.error)
            } else {
              resolve(data)
            }
          } else {
            // reject('Aucune donnée');
          }
        })
        .catch(error => {
          reject(bearer && checkDates(bearer.date) ? redirectMessage : error.message)
        })
        .finally(() => updateBearer())
    })
  }
}

export default Requester
